<template>
  <div>
	  <h2
		  ref="header"
		  class="mb-1 bb-component-heading"
	  >
		  {{ this.data.heading || data.template_heading }}
	  </h2>
	  <VueSlickCarousel v-bind="settings">
		  <div
			  v-for="(components, index) in this.data.components"
			  :key="index"
			  :data="components"
			  :is="components.type"
		  ></div>
	  </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
    name: "Carousel",
    props: ["data"],
    data() {
        return {
            settings: {
                dots: false,
                swipe: true,
                arrows: false,
                slidesToShow: 1.1,
                slidesToScroll: 1,
                infinite: false

            }
        };
    },
    mounted() {
        const headerWidth  = this.$refs.header.clientWidth
        const itemWidth = document.querySelector('.slick-slide').clientWidth;
        document.documentElement.style.setProperty(
            '--last-carousel-item-width',
            headerWidth + 'px'
        );
        document.documentElement.style.setProperty(
            '--last-carousel-item-margin-right',
            '-' + (headerWidth - itemWidth) + 'px'
        )
    },
    components: {
        VueSlickCarousel
    }
};
</script>

<style scoped>
div {
  outline: none;
}
</style>

<style>
.slick-list {
  margin-left: -5px !important;
  padding-left: 5px !important;
  overflow: visible !important;
}
.slick-slide {
  padding-right: 3rem;
  @apply pr-6;
}

.slick-track .slick-slide:last-child {
	/* padding: 0 !important; comment for now, to be discussed, problem is same images display width different width & height if we make last item wider */
	/* width: var(--last-carousel-item-width) !important; */
	/* margin-right: var(--last-carousel-item-margin-right) !important; */
}
</style>
